import { render, staticRenderFns } from "./ShiftList.vue?vue&type=template&id=7f53a814&scoped=true"
import script from "./ShiftList.vue?vue&type=script&lang=js"
export * from "./ShiftList.vue?vue&type=script&lang=js"
import style0 from "./ShiftList.vue?vue&type=style&index=0&id=7f53a814&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f53a814",
  null
  
)

export default component.exports